import { render, staticRenderFns } from "./remainDetail.vue?vue&type=template&id=60cb41ea&scoped=true&"
import script from "./remainDetail.vue?vue&type=script&lang=js&"
export * from "./remainDetail.vue?vue&type=script&lang=js&"
import style0 from "./remainDetail.vue?vue&type=style&index=0&id=60cb41ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cb41ea",
  null
  
)

export default component.exports